// extracted by mini-css-extract-plugin
export var border = "_v-8";
export var brand = "_v-t";
export var button = "_v-l";
export var center = "_v-a";
export var centered = "_v-6";
export var closeButton = "_v-c";
export var disabledWrapper = "_v-m";
export var error = "_v-p";
export var extraLarge = "_v-4";
export var extraSmall = "_v-1";
export var fill = "_v-i";
export var footer = "_v-h";
export var footerAction = "_v-j";
export var footerButtons = "_v-k";
export var header = "_v-7";
export var headerWithClose = "_v-d";
export var icon = "_v-o";
export var info = "_v-s";
export var inline = "_v-9";
export var large = "_v-3";
export var main = "_v-e";
export var modal = "_v-0";
export var nearFull = "_v-5";
export var neutral = "_v-u";
export var noPadding = "_v-g";
export var none = "_v-v";
export var scrollable = "_v-f";
export var small = "_v-2";
export var success = "_v-r";
export var tight = "_v-n";
export var titleIcon = "_v-b";
export var warn = "_v-q";